<template>
  <div class="col-12 pl-10 pr-10 mb-20">
    <div class="card">
      <div class="card_header diff">
        <h5 class="card_title"><i class="ti ti-receipt mr-5"></i>결산내역</h5>
        <div class="tabMenu_inner border-0 tab_ctgy03">
          <ul class="tab_link_box">
            <li :class="{ active: selectTab === 0 }" @click="changeTab(0)">
              주간
            </li>
            <li :class="{ active: selectTab === 1 }" @click="changeTab(1)">
              월간
            </li>
          </ul>
        </div>
      </div>
      <div class="card_body">
        <div class="col-12 mb-15 search_group">
          <h5 class="item_name">
            {{ selectTab == 0 ? "주간 검색" : "월별 검색" }}
          </h5>
          <input v-if="selectTab == 0" type="week" class="form_control wp-20 mr-5 display-inline"
            v-model="logInfo.week_date" @change="infoSearch" />
          <input v-if="selectTab == 1" type="month" class="form_control wp-20 mr-5 display-inline"
            v-model="logInfo.date" @change="infoSearch" />
          <div class="filter-btn diff">
            <button @click="infoClear" type="button" class="btn btn-secondary mlr-5">
              클리어
            </button>
          </div>
        </div>

        <div class="table-responsive text-nowrap dataTables_wrapper">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th>월</th>
                <th v-if="selectTab == 0">주</th>
                <th>송신자</th>
                <th>송신일자</th>
                <th>수신일자</th>
                <th colspan="7">결산파일</th>
              </tr>
            </thead>
            <tbody v-if="isLoading">
              <td colspan="8" class="list_loading">
                <div class="loading_spinner">
                  <div class="loading_circle"></div>
                </div>
              </td>
            </tbody>
            <tbody v-if="monthLogList?.length == 0 && !isLoading">
              <tr>
                <td colspan="9">등록된 데이터가 없습니다.</td>
              </tr>
            </tbody>
            <tbody v-if="monthLogList?.length > 0 && !isLoading">
              <tr v-for="data in monthLogList" :key="data.datetime">
                <td>{{ data.month?.replace("-", '년') }}월</td>
                <td v-if="selectTab == 0">{{ data.week.slice(4, 6) }}</td>
                <td>{{ data.sender ?? "-" }}</td>
                <td>{{ data.send_time?.replace("T", " ").slice(0, 16) }}</td>
                <td>{{ data.recept_date == 0 ? '지급 전' : data.recept_date }}</td>
                <td>
                  <a :href="data.fileExcel" :download="`${data.filename}.xls`" class="excel_area">{{
                    `${data.filename}.xls` }}</a>
                </td>
                <td>
                  <a :href="data.filePdf" :download="`${data.filename}.pdf`" class="pdf_area">{{ `${data.filename}.pdf`
                    }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ThePaging v-if="totalPages > 1" :page="page" :changePage="changePage" :totalPages="totalPages" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { autoLeftPad } from "@/utils/common";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import ThePaging from "@/components/public/ThePaging.vue";
const store = useStore();
const fileExcel = computed(() => store.state.closing.fileExcel);
const filePdf = computed(() => store.state.closing.filePdf);
const monthLogList = computed(() => store.state.closing.monthLogList);
const selectTab = ref(0);
const page = computed(() => store.state.closing.page);
const totalPages = computed(() => store.state.closing.totalPages);
const date = new Date();
const todayWeek = getWeekFromISODate(date);
const todayMonth = `${date.getFullYear()}-${autoLeftPad(
  date.getMonth() + 1,
  2
)}`;
let isLoading = ref(false);
let logInfo = {
  date: todayMonth,
  type: selectTab.value,
  week_date: todayWeek,
};
function getWeekFromISODate(dt) {
  dt.setHours(0, 0, 0, 0);
  dt.setDate(dt.getDate() + 3 - ((dt.getDay() + 6) % 7));
  const week1 = new Date(dt.getFullYear(), 0, 4);
  const weekNumber =
    // 1 +
    Math.round(
      ((dt.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
      7
    );
  return `${dt.getFullYear()}-W${weekNumber}`;
}
const infoSearch = async () => {
  isLoading.value = true;
  store.commit("closing/setPage", 1);
  let reqLogInfo = {
    date:
      selectTab.value == 0
        ? logInfo.week_date.replace("-W", "") ?? ""
        : logInfo.date ?? "",
    type: selectTab.value,
  };
  store.commit("closing/setMonthLogInfo", reqLogInfo);
  await store.dispatch("closing/getMonthLog");
  await listFileAdd();
  isLoading.value = false;
};
const infoClear = () => {
  logInfo.week_date = todayWeek;
  logInfo.date = todayMonth;
  createFn();
};
const listFileAdd = async () => {
  for (const obj of monthLogList.value) {
    let weekCommit;
    let excelAction;
    let pdfAction;
    if (selectTab.value == 0) {
      weekCommit = obj.week;
      obj.filename = `주간결산_${weekCommit}`;
      excelAction = "closing/getWeekProfitExcel";
      pdfAction = "closing/getWeekProfitPdf";
      store.commit("closing/setLogWeekDate", weekCommit);
    } else {
      weekCommit = obj.send_time.replaceAll("-", "").slice(0, 6);
      obj.filename = `월말결산_${weekCommit}`;
      excelAction = "closing/getProfitExcel";
      pdfAction = "closing/getProfitPdf";
      store.commit("closing/setLogMonthDate", weekCommit);
    }

    await Promise.all([store.dispatch(excelAction), store.dispatch(pdfAction)]);
    obj.fileExcel = fileExcel.value;
    obj.filePdf = filePdf.value;
  }
};
const changePage = async (str) => {
  store.commit("closing/setPage", str);
  await store.dispatch("closing/getMonthLog");
};
const changeTab = async (num) => {
  selectTab.value = num;
  createFn();
};
const createFn = async () => {
  isLoading.value = true;
  let reqInfo = {
    type: selectTab.value,
    date: selectTab.value == 0 ? todayWeek.replace("-W", "") : todayMonth,
  };
  store.commit("closing/setPage", 1);
  store.commit("closing/setMonthLogInfo", reqInfo);
  await store.dispatch("closing/getMonthLog");
  await listFileAdd();
  isLoading.value = false;
};

createFn();
</script>
